module.exports = __webpack_public_path__ + "img/375_stores_img7.bca3efd2.png";